export const SelectionItensDefaultProps = {
  SelectionItens: []
};